// src/utils/request.js
import axios from 'axios';
import router from '@/router';
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE, // 从环境变量获取基础URL
  timeout: 10000, // 请求超时时间
});
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 获取当前路由信息
    const currentRoute = router.currentRoute;
    // 根据路由设置不同的token
    let token = '';
    // // 在发送请求之前做些什么
    // if (currentRoute.path.startsWith('/Home')) {
    //   // 主页-普通用户
    //   token = localStorage.getItem('ordinaryToken');
    // } else if (currentRoute.path.startsWith('/recyclingOutlets')) {
    //   // 产业地图-普通用户
    //   token = localStorage.getItem('ordinaryToken');
    // } else {
    //   // 监管登录-监管用户
    //   token = localStorage.getItem('supervisionToken');
    // }
    token = localStorage.getItem('ordinaryToken')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 处理未授权
          break;
        case 403:
          // 处理禁止访问
          break;
        case 404:
          // 处理未找到
          break;
        default:
        // 处理其他错误
      }
    }
    return Promise.reject(error);
  },
);

export default service;
